import PropTypes from 'prop-types';
import React from 'react';
import { DropzoneOptions, FileRejection, useDropzone } from 'react-dropzone';
import { FileType, getFileTypeMimeObject } from './FileTypes';
import { IBaseDropzoneComponentProps } from './Interfaces';

const BaseDropzoneComponent = (props: IBaseDropzoneComponentProps) => {
    const dropzoneOptions: DropzoneOptions = {
        accept: getFileTypeMimeObject(props.acceptedTypes),
        onDropAccepted: props.onSelectFile,
        onDropRejected: props.onFileRejected,
    };

    if (props.maxFiles) {
        dropzoneOptions.maxFiles = props.maxFiles;
    }

    const { getRootProps, getInputProps } = useDropzone({
        ...dropzoneOptions,
    });

    return (
        <section>
            <div
                {...getRootProps({
                    className: props.outerContainerClassname,
                    style: props.outerContainerStyle,
                })}
            >
                <div
                    className={props.innerContainerClassname}
                    style={props.innerContainerStyle}
                >
                    <input id={props.id} {...getInputProps()} />
                    {props.children}
                </div>
            </div>
        </section>
    );
};

export default BaseDropzoneComponent;
